module.exports = __webpack_public_path__ + "img/kulttuuriulkoilureitti_original.f5bf11bc.png";